import { useQuery } from '@hooks/reactQuery';

import { getConfigurationComparisonConfigTypes } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TCMConfigTypesDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CC_CONFIG_TYPES } from '@constants/queryKeys';

export const useQueryConfigurationComparisonConfigTypes = (
	props?: TCMConfigTypesDTO,
): {
	configTypesOptions: TSelectOption<string>[];
	isLoadingConfigTypesOptions: boolean;
} => {
	const { vendor, nodes, version } = props || {};

	const {
		data: configTypesOptions,
		isFetching: isFetchingConfigTypesOptions,
		isLoading: isLoadingConfigTypesOptions,
	} = useQuery<Array<TNameTitle>, TSelectOption<string>[]>({
		queryKey: [CC_CONFIG_TYPES, props],
		queryFn: extractQueryParams(getConfigurationComparisonConfigTypes),
		select: (options: Array<TNameTitle>) => {
			return optionsFormatted(options);
		},
		enabled: [!!vendor, vendor === EVendorsValues.mavenir, version, !!nodes?.length],
		...refetchOptions,
	});

	return {
		configTypesOptions: configTypesOptions || [],
		isLoadingConfigTypesOptions: isLoadingConfigTypesOptions && isFetchingConfigTypesOptions,
	};
};

